import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Item } from 'app/models/item.inferface';
import { Observable } from 'rxjs';

import { ConfirmDialogComponent } from './dialogs-components/confirm-dialog/confirm-dialog.component';
import { DialogDescriptionComponent } from './dialogs-components/dialog-description/dialog-description.component';

export interface IConsultantForwardDialogParams {
  title: string,
  placeholder: string,
  consultants: Item[],
  consultationFormGroup: FormGroup,
  consultationFormGroupControlName: string
}

@Injectable()
export class DialogService {

  constructor(private dialog: MatDialog) { }

  openConfirmDialog(title: string, message: string): MatDialogRef<ConfirmDialogComponent> {
    return this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      height: 'auto',
      disableClose: true,
      data: { title, message }
    });
  }

  openDialogDescription(title: string, placeholder: string, type: string, motivesData?: Item[]): MatDialogRef<DialogDescriptionComponent> {
    return this.dialog.open(DialogDescriptionComponent, {
      width: '350px',
      height: 'auto',
      disableClose: true,
      data: { title, placeholder, motivesData, type }
    });
  }
}
